import React from "react";

export function Item({ className, children, onClick, style }) {
  return (
    <li className={className} style={style} onClick={onClick}>
      {children}
    </li>
  );
}
